if(typeof __WEBPACK_EXTERNAL_MODULE__2938__ === 'undefined') { var e = new Error("Cannot find module 'better-sqlite3'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = __WEBPACK_EXTERNAL_MODULE__2938__;